import React from "react";
import ReservationDateTimeSelectorDaily from "./ReservationDateTimeSelectorDaily";
import ReservationDateTimeSelectorHourly from "./ReservationDateTimeSelectorHourly";
import {
    calculateDayExtensionHours,
    roundedDateWithInterval,
} from "./ReservationDateTimeSelectorUtils";

export { roundedDateWithInterval, calculateDayExtensionHours };

export default function ReservationDateTimeSelectorV2({
    isDailyRental = false,
    children = null,
    ...props
}) {
    if (isDailyRental) {
        return <ReservationDateTimeSelectorDaily {...props}>{children}</ReservationDateTimeSelectorDaily>;
    }
    return <ReservationDateTimeSelectorHourly {...props}>{children}</ReservationDateTimeSelectorHourly>;
}
